document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
        const MultipleSliders = document.querySelectorAll(".revSlider");

        MultipleSliders.forEach((slider) => {
            const prevArrow = slider.parentElement.querySelector(".swiper-button-prev");
            const nextArrow = slider.parentElement.querySelector(".swiper-button-next");
            const paginationEl = slider.parentElement.querySelector(".swiper-pagination");

            new Swiper(slider, {
                direction: "horizontal",
                speed: 1000,
                effect: "slide",
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },

                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },

                pagination: {
                    el: paginationEl,
                    clickable: true,
                },

                breakpoints: {
                    150: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                },
            });
        });
    };

    MultipleSlider();
});

document.addEventListener("DOMContentLoaded", function () {

    const swiperWrapper = document.querySelector(".announcement_slider .swiper-wrapper");
    const slide = swiperWrapper ? swiperWrapper.querySelector(".swiper-slide") : null;

    if (slide) {
        for (let i = 0; i < 10; i++) {
            let clone = slide.cloneNode(true);
            swiperWrapper.appendChild(clone);
        }
    }

    var swiper = new Swiper(".announcement_slider", {
        slidesPerView: "auto",
        loop: true,
        allowTouchMove: false,
        grabCursor: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        speed: 20000,

        breakpoints: {
            150: {
                spaceBetween: 20,
            },
            576: {
                spaceBetween: 20,
            },
            769: {
                spaceBetween: 30,
            },
            1025: {
                spaceBetween: 40,
            }
        }
    });

});

document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
        const MultipleSliders = document.querySelectorAll(".prodCardSlider");

        MultipleSliders.forEach((slider) => {
            const prevArrow = slider.parentElement.querySelector(".swiper-button-prev");
            const nextArrow = slider.parentElement.querySelector(".swiper-button-next");
            // const paginationEl = slider.parentElement.querySelector(".swiper-pagination");

            new Swiper(slider, {
                direction: "horizontal",
                speed: 1000,
                effect: "slide",
                // autoplay: {
                //     delay: 250000,
                //     disableOnInteraction: false,
                // },

                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },

                // pagination: {
                //     el: paginationEl,
                //     clickable: true,
                // },

                breakpoints: {
                    280: {
                        slidesPerView: 1.2,
                        spaceBetween: 15
                    },
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    769: {
                        slidesPerView: 2.5,
                        spaceBetween: 20
                    },
                    1025: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                },
            });
        });
    };

    MultipleSlider();
});

document.addEventListener('DOMContentLoaded', function () {
    const MultipleSlider = () => {
        const MultipleSliders = document.querySelectorAll('.videos_sliders');
        MultipleSliders.forEach((slider, index) => {
            const paginationEl = document.createElement('div');
            paginationEl.classList.add('swiper-pagination');
            paginationEl.classList.add(`pagination-${index}`);
            slider.appendChild(paginationEl);
            new Swiper(slider, {
                direction: 'horizontal',
                grabCursor: true,
                speed: 1000,
                pagination: {
                    el: `.pagination-${index}`,
                    clickable: true,
                },
                breakpoints: {
                    150: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    576: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    769: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    1025: {
                        slidesPerView: 3.2,
                        spaceBetween: 10,
                    },
                },
            });
        });
    };
    MultipleSlider();
});